import { COMMENTS_GET } from '../queries';
import { useInfiniteQuery } from './base';
export const useCommentsQuery = ({ discussionId, endpoint, parentId, }) => {
    const variables = {
        discussionId,
        parentId,
        sortField: 'createdAt',
        sortOrder: 'ASC',
        page: 0,
        perPage: 20,
    };
    const { queryKey, fetchNextPage, fetchPreviousPage, hasNextPage, hasPreviousPage, isFetchingNextPage, isFetchingPreviousPage, data, } = useInfiniteQuery(`comments`, COMMENTS_GET, endpoint, variables);
    let count = undefined;
    const items = data?.pages?.reduce((all, page) => {
        count = page.meta.count;
        all.push(...page.comments);
        return all;
    }, []);
    return {
        queryKey: queryKey,
        fetchNextPage,
        fetchPreviousPage,
        hasNextPage,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        data: items || [],
        count,
        remainingCount: count && items ? (count - items.length) : undefined
    };
};
//# sourceMappingURL=useCommentsQuery.js.map